import { css } from "styled-components";

/**
 * For firefox, arc and sometimes chrome (depending on system settings)
 * thick blocky scrollbars are shown, this code hides them.
 */
export const hideScrollbar = css`
  scrollbar-color: ${({ theme }) => theme.colorSelected} rgba(0, 0, 0, 0);
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* WebKit */
  }
`;
